export enum DAppsTabs {
  Overview = 'overview',
  Monitoring = 'monitoring',
  GasTank = 'gas-tank',
  OrgMonitoring = 'org-monitoring',
}
